import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-12 md:py-32 bg-warm-beige relative overflow-hidden" data-id="element-110">
      {/* Decorative blobs */}
      <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] rounded-full bg-white/40 blur-3xl pointer-events-none" data-id="element-111" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[400px] h-[400px] rounded-full bg-dusty-rose/20 blur-3xl pointer-events-none" data-id="element-112" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl shadow-2xl p-6 md:p-12 text-center border-t-8 border-dusty-rose" data-id="element-114">
          <h2 className="text-3xl font-heading font-bold text-deep-charcoal mb-2" data-id="element-115">
            Empieza tu Transformación Hoy
          </h2>
          <p className="text-deep-charcoal/70 mb-8" data-id="element-116">
            Acceso instantáneo a todo el material
          </p>

          <div className="flex flex-col items-center justify-center mb-8" data-id="element-117">
            <div className="text-lg text-deep-charcoal/60 font-medium mb-2 flex items-center gap-2" data-id="element-118">
              VALOR TOTAL:{' '}
              <span className="line-through decoration-dusty-rose decoration-2" data-id="element-119">
                $208.00
              </span>
            </div>
            <div className="flex items-baseline gap-2" data-id="element-120">
              <span className="text-2xl font-bold text-deep-charcoal" data-id="element-121">
                HOY SOLO:
              </span>
              <span className="text-6xl md:text-7xl font-bold text-dusty-rose tracking-tight" data-id="element-122">
                $14.99
              </span>
              <span className="text-xl font-bold text-dusty-rose" data-id="element-123">USD</span>
            </div>
          </div>

          <a href="https://rutinasimple.com//cart/52146528747801:1" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart');
          }
        }} className="group relative w-full flex items-center justify-center px-8 py-5 text-lg md:text-xl font-bold text-white transition-all duration-300 bg-dusty-rose rounded-2xl hover:bg-dusty-rose/90 hover:shadow-xl hover:-translate-y-1 mb-4 no-underline" data-id="element-124">
            SÍ, QUIERO MI PACK CÓDIGO HORMONAL AHORA
            <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-125" />
          </a>

          <p className="text-deep-charcoal font-medium mb-6" data-id="element-126">
            ¡Quiero empezar a sincronizar mi cuerpo hoy mismo!
          </p>

          <div className="flex items-center justify-center gap-2 text-sm text-deep-charcoal/60 bg-cream-white py-3 px-4 rounded-lg inline-flex" data-id="element-127">
            <Download className="w-4 h-4" data-id="element-128" />
            <span data-id="element-129">Pago único. Descarga inmediata en PDF</span>
          </div>
        </motion.div>
      </div>
    </section>;
}